<template>
  <section id="admin-settings-search-filter">
    <el-collapse v-model="isOpen">
      <el-collapse-item
          id="admin-settings-search-section"
          :title="$t('common.search')"
          name="admin-settings-search-section"
      >
        <el-form
            id="admin-settings-search-section-form"
            ref="searchForm"
            class="search-section-form"
            :model="searchFormModel"
            label-position="right"
            size="mini"
            inline
            @submit.native.prevent
        >
          <el-row :gutter="10">
            <el-col :span="14" >
              <el-form-item :label="$t('admin.userGroups.searchGroup')">
                <autocomplete :disabled="searchFormModel.shipper == null"
                    :model.sync="searchFormModel.group"
                    :shipperAccountId="null"
                    labelFieldLastWithDash="number"
                    popperAppendToBody
                    :url="autocompleteUrl"
                    labelField="name"
                    valueField="number"
                    valueFieldAdditional="name"
                    ref="accountCode"
                    id="accountCode"
                    autocomplete="off"
                    aria-autocomplete="none"
                    :selectAction="handleSearch"
                    :clearAction="handleSearch"
                />
              </el-form-item>
            </el-col>

            <el-col span="10" class="text-align-end">
              <el-form-item prop="type">
                <el-radio-group v-model="searchFormModel.shipper" size="mini" @change="handleSearch">
                  <el-radio-button :label="true">Shipper</el-radio-button>
                  <el-radio-button :label="false">Consignee</el-radio-button>
                  <el-radio-button :label="null">No role</el-radio-button>
                </el-radio-group>
              </el-form-item>
            </el-col>
          </el-row>

          <el-row :gutter="10">
            <el-col :span="14">
              <el-form-item :label="$t('admin.userGroups.search')">
                <el-input
                    :placeholder="$t('admin.userGroups.searchPlaceholder')"
                    v-model="searchFormModel.value"
                    v-email-validation
                    clearable
                    class="inline-input"
                    @clear="handleSearch"
                    @keyup.enter.native="handleSearch"
                />
              </el-form-item>
            </el-col>

            <el-col :span="8" class="text-align-end">
              <el-tooltip
                  :content="$t('common.search')"
                  class="item"
                  effect="dark"
                  placement="top-start"
              >
                <el-button
                    id="admin-settings-search-section-form-button"
                    class="button-action-default"
                    icon="el-icon-search"
                    size="mini"
                    @click="handleSearch"
                />
              </el-tooltip>
            </el-col>
          </el-row>
        </el-form>
      </el-collapse-item>
    </el-collapse>
  </section>
</template>

<script>
import { mapActions } from 'vuex';
import constants from '@/utils/constants';
import apiConstants from '@/utils/apiConstants';
import Autocomplete from '@/components/Autocomplete';
import { USER_GROUPS_SEARCH } from '@/store/actions';

export default {
  name: 'UserGroupsSearchSection',
  components: {
    Autocomplete
  },
  data() {
    return {
      activeCollapsibleName: ['user-groups-search-section'],
      isOpen: ['admin-settings-search-section'],
      searchFormModel: {
        value: null,
        group: null,
        shipper: false,
        page: constants.TABLES.DEFAULT_PAGE
      }
    };
  },
  computed: {
    autocompleteUrl() {
      // Logic safety: if shipper is null, this won't be used anyway as the field is hidden
      return this.searchFormModel.shipper
        ? apiConstants.END_POINTS.ACCOUNTS.SHIPPERS
        : apiConstants.END_POINTS.ACCOUNTS.CONSIGNEE;
    }
  },
  watch: {
    'searchFormModel.shipper': {
      handler(newVal) {
        // If "No role" (null) is selected, reset the group value
        if (newVal === null) {
          this.searchFormModel.group = null;
        }
        this.handleSearch();
      }
    }
  },
  mounted() {
    this.handleSearch();
  },
  methods: {
    ...mapActions({
      search: USER_GROUPS_SEARCH
    }),
    handleSearch() {
      this.search(this.searchFormModel);
      this.$emit('search-performed', this.searchFormModel.shipper);
    },
    resetAndSearch() {
      this.searchFormModel = {
        value: null,
        group: null,
        shipper: null, // O el valor por defecto que prefieras
        page: constants.TABLES.DEFAULT_PAGE
      };
      this.handleSearch();
    }
  }
};
</script>
